import { render, staticRenderFns } from "./benefits-toggle.vue?vue&type=template&id=5f35d224&scoped=true"
import script from "./benefits-toggle.vue?vue&type=script&lang=js"
export * from "./benefits-toggle.vue?vue&type=script&lang=js"
import style0 from "./benefits-toggle.vue?vue&type=style&index=0&id=5f35d224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35d224",
  null
  
)

export default component.exports